module.exports = __webpack_public_path__ + "img/Imagen31.96b66a39.png";